export const ensureCorrectCommissionFormat = value => value.replace(',', '.')

export const buildCommonInsuranceContractParameters = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  action = 'save',
}) => {
  const options = new URLSearchParams()

  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('action', action)

  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('product_type', characteristicsData.productType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  options.append('provider_external_id', contractData.providerExternalId || '')

  if (contractData.annualPremium?.length > 0) {
    options.append('annual_premium', ensureCorrectCommissionFormat(contractData.annualPremium))
  }
  if (contractData.annualCommission?.length > 0) {
    options.append('annual_commission', ensureCorrectCommissionFormat(contractData.annualCommission))
  }

  return options
}
